import { requestRmaProductListStyles } from "@insite/content-library/Widgets/RequestRma/RequestRmaProductList";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import { css } from "styled-components";

requestRmaProductListStyles.qtyToReturnTextField = {
    cssOverrides: {
        formInputWrapper: css`
            width: 40%;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css`
                            width: 55%;
                        `,
                        null,
                        css`
                            width: 84%;
                        `,
                        css`
                            width: 56%;
                        `,
                    ],
                    "minMax",
                )}
        `,
    },
};
requestRmaProductListStyles.productInfoBrandDescriptionGridContainer = {
    gap: 5,
    css: css`
        > div[class^="GridOffset"] {
            width: 100%;
        }
    `,
};
requestRmaProductListStyles.productInfoGridContainer = {
    gap: 5,
    css: css`
        > div[class^="GridOffset"] {
            width: 100%;
        }
    `,
};
requestRmaProductListStyles.gridContainer = {
    css: css`
        margin-bottom: 25px;
        > div[class^="GridOffset"] {
            width: 100%;
            margin: 0;
        }
    `,
};
requestRmaProductListStyles.returnReasonGridItem = {
    width: [9, 9, 3, 3, 3],
    printWidth: 0,
    css: css`
        flex-direction: column;
        margin-left: auto !important;
        > div[class^="FormFieldStyle"]:last-child {
            select[data-test-selector^="requestRmaLine_ReturnReason"] {
                padding-right: 40px;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
            }
        }
    `,
};
